<div class="input-container">
  <div class="field-container">
    <span>{{label}}</span>
    <div #colorInput class="input" [class.selected]="selectedColor" [class.invalid]="control!.touched && control!.invalid" tabindex="0" (focus)="handleFocus()" (blur)="handleBlur()">
      <span>{{selectedColor ? ('controls.color_selected' | translate) : placeholder}}</span>
      <div class="color small" [style.background-color]="selectedColor"></div>
      <i class="fas fa-chevron-down"></i>
      <div [class.open]="expanded" [class.close]="!expanded" class="colors-grid">
        <div *ngFor="let color of colors" class="color" [style.background-color]="color" [class.selected]="color === selectedColor" (click)="colorChange(color)"></div>
      </div>
    </div>
    <span *ngIf="control?.touched && !isFocused && control?.errors" class="validation-message">
      <ng-container *ngIf="control!.errors!['required']">Bitte wähle eine Farbe aus</ng-container>
    </span>
  </div>
</div>